import React from "react";

const Bixu =()=>{
    return(
        <div className="regulations-detail">
            <div>
                <div><div></div><div><ul><li></li></ul></div></div>
                <div>
                    <div className="box-list-style">
                        <b className="index">1. Quy định Tích Bixu</b>
                    </div>
                    <div >
                        <ul className="pdl-20">
                            <li>Bixu sẽ được cộng vào Ví của Ba Mẹ ngay khi hoàn tất giao dịch mua sắm, săn xu,  trúng thưởng hoặc làm nhiệm vụ thành công.</li>
                            <li>Bixu vừa nhận sẽ được hệ thống kích hoạt sau 24h. Ba Mẹ có thể tiêu số Bixu vừa tích được vào ngày D+1 kể từ ngày tích.</li>
                            <li>Quy đổi 1 Bixu = 1 đồng.</li>
                        </ul>
                    </div>
                </div>

                <div>
                    <div className="box-list-style">
                        <b className="index">2. Quy định hoàn trả Bixu</b>
                    </div>
                    <div >
                        <ul className="pdl-20">
                        <li>Nếu Ba Mẹ hoàn/hủy đơn hàng, Bixu sẽ được hoàn lại vào Ví của Ba Mẹ ngay khi hoàn tất giao dịch hoàn/huỷ.</li>
                        </ul>
                    </div>
                </div>

                <div>
                    <div >
                        <b className="index">3. Hiệu lực của Bixu</b>
                    </div>
                    <div className="box-list-style">
                        <ul className="pdl-20">
                        <li>Bixu có hiệu lực trong vòng 90 ngày kể từ ngày mua sắm gần nhất. Ba Mẹ cần đảm bảo có giao dịch mua sắm phát sinh trong vòng 90 ngày kể từ ngày tích xu để kích hoạt Bixu.</li>
                        <li>Bixu hết hiệu lực sẽ bị trừ khỏi Ví.</li>
                        <li>Bixu có thể tiêu trong thời gian còn hiệu lực và trên toàn hệ thống Bibo Mart (bao gồm các siêu thị offline và mua hàng trực tuyến qua website và App Bibo Mart).</li>
                        <li>Bixu không áp dụng tiêu khi mua hàng trên các sàn TMĐT và các kênh livestream trên các nền tảng xã hội như Tiktok, Shopee... của Bibo Mart.</li>
                        </ul>
                    </div>
                </div>
                <div>
                    <div >
                        <b className="index">4. Quy định Tiêu Bixu</b>
                    </div>
                    <div className="box-list-style">
                        <ul className="pdl-20">
                        <li>Bixu có thể dùng để đổi quà ở trang Đổi quà</li>
                        <li>Bixu không có giá trị quy đổi thành tiền mặt và cho/tặng giữa các tài khoản.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Bixu;